"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const TableHeader_1 = __importDefault(require("@Components/ViewWork/Table/TableHeader"));
const TableFooter_1 = __importDefault(require("@Components/ViewWork/Table/TableFooter"));
const TableBody_1 = __importDefault(require("@Components/ViewWork/Table/TableBody"));
const Table = ({ headerRow, rows, footerRow, onRemoveCells }) => {
    const tableIsEmpty = rows.length === 0;
    return (react_1.default.createElement(react_1.default.Fragment, null, !tableIsEmpty && (react_1.default.createElement("div", { className: 'table' },
        headerRow && react_1.default.createElement(TableHeader_1.default, { row: headerRow.row, removableCells: headerRow.removableCells }),
        react_1.default.createElement(TableBody_1.default, { rows: rows, removableCells: headerRow === null || headerRow === void 0 ? void 0 : headerRow.removableCells, onRemoveCellClicked: (index, removeCellIdentifier) => {
                onRemoveCells && onRemoveCells(index, removeCellIdentifier);
            } }),
        footerRow && react_1.default.createElement(TableFooter_1.default, { row: footerRow })))));
};
exports.default = Table;
